import styled, { css } from "styled-components";
export const FixedWrap = styled.div `
    position: fixed;
    right: 20px;
    bottom: 280px;
    z-index: 30;
`;
export const Icon = styled.div `
    width: 64px;
    height: 64px;
    position: absolute;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
	background: #CCCCCC;
`;
export const SpanImg = styled.span `
	display: inline-block;
	width: 100%;
	height: 100%;
	background-image: url(${(props) => props.bgImg});
	background-size: cover;
`;
export const IconMobile = styled(Icon) `
    top: 92px;
    background: #EACAC8;
    :hover {
        background: #e33124;
		.icon {
			background-image: url(${(props) => props.bghImg});
		}
    }
`;
export const IconCustomer = styled(Icon) `
    top: 166px;
    .icon {
        width: 38px;
        height: 38px;
    }
	:hover {
        background: #e33124;
		.icon {
			background-image: url(${(props) => props.bghImg});
		}
    }
	:hover + .customer{
		display: block;
	}
`;
export const IconTop = styled(Icon) `
    top: 18px;
    :hover {
        background: #e33124!important;
		.icon {
			background-image: url(${(props) => props.bghImg});
		}
    };
    ${(props) => !props.isShow && css `
        opacity: 0;
        transition: all 600ms;
    `}
`;
export const MobileWrap = styled.dl `
    height: auto;
    background: #fff;
    position: absolute;
    right: 75px;
    transform: translateY(-39%);
    padding: 15px 20px 15px 10px;
    border: 1px solid #ccc;
    border-radius: 3px;
	display: none;
    box-shadow: 0px 6px 6px 0px rgba(0,0,0,0.05);
    top: 106px;
    dt {
        font-size: 14px;
        font-weight: 500;
        margin-bottom: 8px;
        >span {
            color: #e33124 !important;
            font-style: normal;
            font-size: 16px;
            font-weight: 500 !important;
        }
    }
    >i {
        display: inline-block;
        width: 0;
        height: 0;
        border-top: 8px solid transparent;
        border-right: 8px solid transparent;
        border-bottom: 8px solid transparent;
        border-left: 8px solid #ccc;
        position: absolute;
        right: -17px;
        top: 47%;
    }
    >i::after {
        content: "";
        display: inline-block;
        width: 0;
        height: 0;
        border-top: 8px solid transparent;
        border-right: 8px solid transparent;
        border-bottom: 8px solid transparent;
        border-left: 8px solid #fff;
        position: absolute;
        right: -7px;
        top: -8px;
    }
`;
export const Mobile = styled.div `
	:hover {
		.mobile {
			display: block;
		}
	}
	a:hover {
		color: #fff;
	}
`;
export const MobileMain = styled.dd `
    display: flex;
    justify-content: center;
    height: 80px;
    width: 100%;
`;
export const QrCodeWrap = styled.span `
    display: inline-block;
    width: 78px;
    height: 78px;
    margin-right: 10px;
	background: url("https://lijc.rightinthebox.com/lightsource/img/index/back_top_qr_code_lightinthebox_40a5fdc1c5b185fe.png") no-repeat;
	background-size: 100%;
`;
export const OurMobileWrap = styled.span `
    display: inline-block;
    width: 148px;
`;
export const OurMobileA = styled.a `
    display: inline-block;
    width: 90px;
    height: 35px;
    background: #333;
    border-radius: 2px;
    padding: 0 20px;
    font-size: 12px;
    font-weight: 500;
    color: #fff;
    line-height: 35px;
    text-decoration: none;
    margin-bottom: 10px;
    img {
        display: inline-block;
        width: 15px;
        margin-right: 7px;
        vertical-align: middle;
    }
`;
export const Tips = styled.p `
    position: absolute;
    right: 75px;
    background: rgba(0,0,0, .75);
    color: #fff;
    white-space: nowrap;
    padding: 8px 18px;
    border-radius: 2px;
    font-size: 14px;
    display: none;
    >i {
        display: inline-block;
        width: 0;
        height: 0;
        border-top: 5px solid transparent;
        border-right: 5px solid transparent;
        border-bottom: 5px solid transparent;
        border-left: 5px solid rgba(0,0,0,.75);
        position: absolute;
        right: -10px;
        top: 32%;
    }
`;
export const TipsCustomer = styled(Tips) `
    top: 183px;
`;
